import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import React, { useEffect } from "react";
import styles from "../../styles/pages/mymessagePurchasedRequest.module.scss";
import assest from "../../json/assest";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import AttachFiles from "../AttachFiles/AttachFiles.jsx";
import AgentTagList from "../AgentTagList/AgentTagList";
import MessageStatus from "../MessageStatus/MessageStatus";
import MessagePageLeftHeading from "../MessagePageLeftHeading/MessagePageLeftHeading";
import MessageDetailsRightPanel from "../MessageDetailsRightPanel/MessageDetailsRightPanel";
import { getCookie } from "../../lib/functions/storage.lib";
import axiosInstance from "../../api/axiosInstance";
import {
  getDateTime,
  getStyledDateTime,
  getUtcDateTime,
  styledDateTime,
} from "../../lib/functions/utils.lib";
import PurchasedBox from "../PurchasedBox/PurchasedBox";
import PurchasePageLeftHeading from "../PurchaseRequestComponents/PurchasePageLeftHeading";
import { Link, useParams } from "react-router-dom";
import PurchaseRequestDecision from "../PurchaseRequestComponents/PurchaseRequestDecision";
import PurchaserequestDetailsRightPanel from "../PurchaseRequestComponents/PurchaserequestDetailsRightPanel";
import useNotiStack from "../../hooks/useNotistack";
import ApiLoader from "../Loaders/ApiLoader";

const PurchaseRequestDetailsCard = (props) => {
  const { id } = useParams();
  const { toastSuccess, toastError } = useNotiStack();

  const updateInquiry = async (purchaseData) => {
    const { data } = await axiosInstance.post(
      `admin/update-purchase-request/${id}`,
      purchaseData
    );
    toastSuccess(data?.message);
    props.refetchPurchaseRequestData();
    return data;
  };
  const userCookie = getCookie("userdetails");
  const user = JSON.parse(userCookie ? userCookie : "{}");

  const [respondToInquiry, setRespondToInquiry] = React.useState(false);
  const [decision, setDecision] = React.useState(
    props?.purchaseRequest?.status
  );

  useEffect(() => {
    setDecision(props?.purchaseRequest?.status);
  }, [props?.purchaseRequest?.status]);

  const toggleRepondToInquiry = () => {
    setRespondToInquiry((prev) => !prev);
  };

  const handleDecisionUpdate = (newValue) => {
    setDecision(newValue);
    updateInquiry({
      ...props?.purchaseRequest,
      status: newValue,
    });
  };

  const updateVsid = (data) => {
    updateInquiry({
      ...props?.purchaseRequest,
      video_id: data,
    });
  };
  return (
    <Stack direction="row" flexWrap="wrap" className={styles.msgColumn}>
      <ApiLoader loading={props?.isLoading || props?.isRefetching} />
      <Box className={styles.detailsColLeft}>
        <PerfectScrollbar className={styles.purchasedLeftScroll}>
          <Box className={styles.msgdetails}>
            <PurchasePageLeftHeading headingText={"Request Details"} />
            <Paper className={`${styles.styledPaper} ${styles.forMsgDetails}`}>
              <Box className={styles.papperBottomDetails}>
                <Box className={styles.sideGapWrap}>
                  <Typography variant="caption">Video URL:</Typography>
                  <Typography variant="body1">
                    <Link
                      to={props?.purchaseRequest?.video_url}
                      target="_blank"
                    >
                      {props?.purchaseRequest?.video_url
                        ? props?.purchaseRequest?.video_url
                        : "N/A"}
                    </Link>
                  </Typography>
                  <Typography variant="caption">Notes:</Typography>
                  <Typography variant="body1">
                    {props?.purchaseRequest?.notes
                      ? props?.purchaseRequest.notes
                      : "-"}
                  </Typography>
                  <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                    flexWrap="wrap"
                    className={styles.codeStack}
                  >
                    <Typography variant="body2">
                      PRID:{" "}
                      <span>
                        #
                        {props?.purchaseRequest?.id
                          ? props?.purchaseRequest?.id
                          : "N/A"}
                      </span>
                    </Typography>
                  </Stack>
                </Box>
                <Box className={`${styles.createdDate} ${styles.sideGapWrap}`}>
                  <Typography variant="caption">
                    Purchase Requested on:
                  </Typography>
                  <Typography variant="body1">
                    {props?.purchaseRequest?.created
                      ? styledDateTime(props?.purchaseRequest?.created)
                      : "N/A"}
                  </Typography>
                </Box>
              </Box>
            </Paper>
          </Box>
          <AttachFiles attachments={props?.purchaseRequest?.attachemts} />
          <PurchasedBox
            purchased={props?.purchaseRequest?.purchased}
            updateVsid={updateVsid}
            video={props?.purchaseRequest?.video}
          />
          <PurchaseRequestDecision
            initialValue={decision}
            onUpdate={handleDecisionUpdate}
          />
        </PerfectScrollbar>
      </Box>
      <PurchaserequestDetailsRightPanel
        inquiry={props?.purchaseRequest}
        respondToInquiry={respondToInquiry}
        toggleRepondToInquiry={toggleRepondToInquiry}
        refetchPurchaseRequestData={props?.refetchPurchaseRequestData}
      />
    </Stack>
  );
};

export default PurchaseRequestDetailsCard;
